import { LayoutSectionParentKey, } from "./layout-item";
export var HostedFormTokenStatus;
(function (HostedFormTokenStatus) {
    HostedFormTokenStatus["Active"] = "Active";
    HostedFormTokenStatus["Completed"] = "Completed";
    HostedFormTokenStatus["Expired"] = "Expired";
})(HostedFormTokenStatus || (HostedFormTokenStatus = {}));
export const hostedFormClientContainerKey = (hostedFormId) => `Custom_${LayoutSectionParentKey.HostedFormClient}_${hostedFormId}`;
export const hostedFormClientSectionKey = (hostedFormId, sectionKey) => `Custom_${sectionKey}_${hostedFormId}`;
//# sourceMappingURL=hosted-form.js.map